export const shareData = {
  title: 'Carvana Vehicle Detail Page'
};
